module.exports = __webpack_public_path__ + "img/cs-question.371d61cf.png";